import React, {useState, useEffect} from 'react';
import post from '../utils/post.js';
import PopupSearch from './PopupSearch.js';
import usePopupAnimation from '../utils/usePopupAnimation.js';

export default function MessageSysadminReaded({showReaded, closeReaded, messageId}) {
	const popupAnimationMs = 300;
	const [data, setData] = useState([]);
	const [search, setSearch] = useState('');
	const [searchOptions, setSearchOptions] = useState([]);
	const {shouldRender, isClosing} = usePopupAnimation(showReaded, popupAnimationMs);

	useEffect(() => {
		if (showReaded) {
			setSearch('');
			getData();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showReaded]);

	const getData = () => {
		post('getReadedMessage', {ID: messageId})
			.then((res) => {
				setData(res.data);
				setSearchOptions(res.data);
			})
			.catch((error) => {
				console.error(error);
			});
	};

	const setVals = (value) => {
		setSearch(value);

		let pom = data.filter((item) => {
			return item.USRNAME.toLowerCase().includes(value.toLowerCase());
		});

		setSearchOptions(pom);
	};

	const list = searchOptions.map((line, index) => {
		return (
			<div className="message-readed-popup__item" key={line.ID || index}>
				<div className="message-readed-popup__name">{line.USRNAME}</div>
				<div className="message-readed-popup__date">{line.CRDTS}</div>
			</div>
		);
	});

	return (
		<>
			{shouldRender ? (
				<div className={`popup message-readed-popup${isClosing ? ' popup--closing' : ''}`}>
					<div className={`popup_content message-readed-popup__content${isClosing ? ' popup_content--closing' : ''}`}>
						<div className="popup_content_in_head">
							<div className="popup_content_in_head_in">Zprávu četli</div>
							<img
								alt=""
								className="popup_content_in_head_in-close"
								onClick={() => {
									closeReaded();
								}}
							/>
						</div>
						<div className="popup_content_in_body popup_content_in_body--hidden-scrollbar message-readed-popup__body">
							<div className="popup_content_in_body_in message-readed-popup__body-in">
								<div className="message-readed-popup__search-wrap">
									<PopupSearch searchValue={search} onChangeSearch={(value) => setVals(value)} placeholder="Vyhledat podle jména" className="message-readed-popup__search" />
								</div>
								<div className="popup_content_in_body--hidden-scrollbar message-readed-popup__list-wrap">
									<div className="message-readed-popup__list">
										{list.length > 0 ? list : <div className="message-readed-popup__empty">Nikdo zatím zprávu nepřečetl.</div>}
									</div>
								</div>
							</div>
						</div>
						<div className="popup_content_in_foot">
							<div className="popup_content_in_foot_in">
								<button
									type="button"
									className="button"
									onClick={() => {
										closeReaded();
									}}
								>
									Zpět
								</button>
							</div>
						</div>
					</div>
				</div>
			) : (
				''
			)}
		</>
	);
}
